

// @ts-nocheck

import Vue from "vue";
import { decode } from "../../../../../../../Overarching Resources/TS/Survey/surveyHelperMethods"


export default Vue.extend({
  data() {
    return {
      fieldLocal: "",
      initialOfficialLangEncoded: false,
      initialOfficialLangPhrase: false,
    };
  },
  props: {
    label: String,
    fieldAddress: Array,
    validation: String,
    placeholder: String,
    fieldDescription: {
      type: [String,Boolean],
      default: false
    },
    allowAction: {
      type: Boolean,
      default: true,
    },
  },
  created(): void {

    if (this.field === false) return;

    let decoded = decode(this.field as string);

    if (decoded) { 
      //official language field
      this.fieldLocal = this.$store.getters["dash/specificLanguagePack"](
        decoded.languagePackSlug
      )[decoded.slug].replaceAll('[businessname]', this.$store.state.dash.viewData.business.businessInfo.businessName);
      // @ts-ignore //computed prop type not picked up correctly
      this.initialOfficialLangEncoded = this.field;
      // @ts-ignore //computed prop type not picked up correctly
      this.initialOfficialLangPhrase = this.fieldLocal;
    } else {
      this.fieldLocal = this.field;
    }
    

  },
  computed: {
    field: {
      get: function (): string | false {
        // @ts-ignore
        return this.$store.getters["survey/stepField"](this.fieldAddress);
      },
      set: function (v: string): void {
        // @ts-ignore
        this.$store.commit("survey/CHANGE_FIELD", {
          // @ts-ignore
          fieldAddress: this.fieldAddress,
          val: v,
        });
      },
    },
  },
  watch: {
    fieldLocal(v): void {
      
      //order of error check is out of whack, so 1ms timeout needed to wait for js execution
      setTimeout(() => {
        // @ts-ignore //errors not picked up
        if (this.errors.any()) {
          //noconsoleconsole.log('haserror')
          this.$emit("handleErrors", {fieldAddress: this.fieldAddress, hasErrors: true});
        } else {
          //noconsoleconsole.log('NOThaserror')
          this.$emit("handleErrors", {fieldAddress: this.fieldAddress, hasErrors: false});
        }
      }, 1);

      if (this.initialOfficialLangPhrase === v) {
        // @ts-ignore //errors not picked up
        this.field = this.initialOfficialLangEncoded; //if we change it back to the official dictionary item, then record it so in the DB
        //console.log('field set back to original: ' + this.initialOfficialLangEncoded)
      } else {
        this.field = v.trim().length === 0 ? false : v;
      }
    },
  },
  methods: {
    action(): void {
      // @ts-ignore
      this.fieldLocal = "";
    },
  },
});
